import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { PATH_PAGE_NOT_FOUND } from 'src/app/global';
import {
  PATH_CREATE_PATIENT,
  PATH_EDIT_PATIENT,
  PATH_ID_PARAM,
  PATH_PATIENTS,
} from '../patients.global';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PatientFormComponent } from './patient-form/patient-form.component';

export interface MedicalConditionForm {
  name: string;
  altName: string;
}

export interface InterdisciplinaryTeamForm {
  specialization: string;
  name: string;
  title: string;
}

@Component({
    selector: 'app-create-patient-page',
    templateUrl: './create-patient-page.component.html',
    styleUrls: ['./create-patient-page.component.scss'],
    standalone: true,
    imports: [BreadcrumbModule, PatientFormComponent],
})
export class CreatePatientPageComponent implements OnInit {
  breadcrumbItems: MenuItem[] = [
    { label: 'Patient List', routerLink: `/${PATH_PATIENTS}` },
    { label: 'Create Patient' },
  ];

  prefillForm = false;
  type = '';
  pid: string | null;

  private router = inject(Router);
  private route = inject(ActivatedRoute);

  constructor() {
    // Get type from the router URL ('create-patient' or 'edit-patient/:id')
    this.type = (this.route.snapshot.routeConfig?.path as string).split('/')[0];

    // Get patient ID (if it exists in path)
    this.pid = this.route.snapshot.paramMap.get(PATH_ID_PARAM);
    if (!this.isValidPath) {
      this.router.navigate([PATH_PAGE_NOT_FOUND]);
    } else {
      this.prefillForm = true;
    }
  }

  ngOnInit(): void {}

  get isValidPath() {
    return (
      this.isCreatePatientPage || (this.isEditPatientPage && this.pid !== null && this.pid !== '')
    );
  }

  get isCreatePatientPage() {
    return this.type.toLocaleLowerCase() === PATH_CREATE_PATIENT;
  }

  get isEditPatientPage() {
    return this.type.toLocaleLowerCase() === PATH_EDIT_PATIENT;
  }
}
